import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetBOUserDetailsRPC } from "./getBoUserDetailsRPC";

export class GetBOUserDetailsRPCClientImpl extends GetBOUserDetailsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetBOUserDetailsRPC.Request): Promise<LeoRPCResult<GetBOUserDetailsRPC.Response, GetBOUserDetailsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "bo-user-management/GetBOUserDetails",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetBOUserDetailsRPC.ResponseDTO,
      GetBOUserDetailsRPC.Errors.ErrorsDTO,
      GetBOUserDetailsRPC.Response,
      GetBOUserDetailsRPC.Errors.Errors
    >(
      response,
      "bo-user-management/GetBOUserDetails",
      GetBOUserDetailsRPC.Response.fromDTO,
      GetBOUserDetailsRPC.Errors.fromDTO
    );
  }
}
